import { render, staticRenderFns } from "./account-overview.page.vue?vue&type=template&id=3b6d8146&"
import script from "./account-overview.page.vue?vue&type=script&lang=ts&"
export * from "./account-overview.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports